// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2336":"51961ebd","4050":"717f514d","4965":"f3ebe232","6911":"1575e7a9","9449":"7f6f4663","9604":"285c12ec"}[chunkId] + ".chunk.css";
};